export const normalizeItemSearch = (value) =>
  (value ?? '').toString().trim().toLowerCase();

const itemNameValues = (item) => [
  item?.ItemName,
  item?.itemName,
  item?.itemname,
];

const itemBarcodeValues = (item) => [
  item?.barcode,
  item?.defbarcode,
  item?.defBarcode,
  item?.ItemID,
  item?.itemId,
  item?.itemid,
];

export const matchesItemBarcode = (item, query) => {
  const normalizedQuery = normalizeItemSearch(query);
  if (!normalizedQuery) return true;

  return itemBarcodeValues(item).some(
    (value) => normalizeItemSearch(value) === normalizedQuery
  );
};

export const matchesItemSearch = (item, query, extraValues = []) => {
  const normalizedQuery = normalizeItemSearch(query);
  if (!normalizedQuery) return true;

  return [...itemNameValues(item), ...itemBarcodeValues(item), ...extraValues]
    .some((value) => normalizeItemSearch(value).includes(normalizedQuery));
};
